module.exports = __webpack_public_path__ + "static/gallery_treehouse_6_thumb-f00fd8b96e7831d5fe6a9ae32792d46f.jpg";